/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_OrderInputs */

const en_queue_order = /** @type {(inputs: Queue_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const de_queue_order = /** @type {(inputs: Queue_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Queue_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const queue_order = /** @type {((inputs?: Queue_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_order(inputs)
	return de_queue_order(inputs)
});